import {Component, OnDestroy, OnInit} from '@angular/core';
import {Localiser} from "../../services/localiser";
import {UserService} from "../../services/user.service";
import {autotestProyecto} from "../../models/autotestProyecto";
import {AutotestService} from "../../services/autotest.service";
import {proyecto} from "../../models/proyecto";
import {Observable} from "rxjs";
import {WebSocketService} from "../../services/web-socket.service";
import {autotest} from "../../models/autotest";
import {DeviceService} from "../../services/device.service";
import {Navigation} from "../../services/navigation.service";
import {MatDialog} from "@angular/material/dialog";
import {luminaria} from "../../models/luminaria";
import {EditComponent} from "../devices/edit/edit.component";
import {WarningComponent} from "./warning/warning.component";
import {LuminariaService} from "../../services/luminaria.service";

@Component({
  selector: 'app-autotest',
  templateUrl: './autotest.component.html',
  styleUrls: ['./autotest.component.css']
})
export class AutotestComponent implements OnInit, OnDestroy {

  observableAutotest!: Observable<any>;
  lastAutotests: Array<autotestProyecto> = [];
  runningAutotest: Array<string> = [];
  selectedProyecto: proyecto = undefined;
  selectedAutotestProyecto: autotestProyecto = undefined;
  loadedHistory: boolean = false;
  autotestProyectoHistory: Array<autotestProyecto> = [];

  showHistory: boolean = false;
  showAutotest: boolean = false;

  autoSaveInterval;

  constructor(public localiser: Localiser, public user: UserService, public autotestService: AutotestService,
              public webSocketService: WebSocketService, public deviceService: DeviceService, public navigation: Navigation,
              public matDialog: MatDialog) {
    this.autoSaveInterval = setInterval(() => {
      let elements = document.getElementsByClassName("flashRed");
      for (let i = 0; i < elements.length; i++) {
        let element = elements.item(i);
        if (element.classList.contains("red")) {
          element.classList.remove('red');
        } else {
          element.classList.add('red');
        }
      };
    }, 500);
  }

  ngOnInit(): void {
    this.init();
    this.observableAutotest = this.webSocketService.getOberserverAutotest();
    this.observableAutotest.subscribe(result => {
      this.addDynamicAutotest(result)
    });
  }

  ngOnDestroy() {
    clearInterval(this.autoSaveInterval);
  }

  init() {
    this.getLastByProyectoFromAPI();
  }

  getLastByProyectoFromAPI() {
    let arr = [];
    for (let proyecto of this.user.getProyectos()) {
      this.autotestService.getLastByIdProyecto(proyecto.idProyecto).subscribe((result: autotestProyecto) => {
        arr.push(result);
      }, error => {
        // 404: el proyecto todavía no tiene ningún autotest, la vista ya muestra
        // "nunca" cuando no hay entrada para el proyecto.
        if (error.status != 404) {
          console.error(error);
        }
      })
    }
    this.lastAutotests = arr;
  }

  getLastByIdProyecto(idProyecto: string) {
    return this.lastAutotests.find(test => test.idProyecto == idProyecto);
  }

  getDate(n: number) {
    return this.getDateAndHour(n).split(',')[0];
  }

  getHourAndMinutes(n: number) {
    let time = this.getDateAndHour(n).split(',')[1].split(':');
    return time[0] + ":" + time[1];
  }

  getDateAndHour(n: number) {
    let date = new Date(n);
    return date.toLocaleString();
  }

  startNewAutotest(proyecto: proyecto) {
    this.runningAutotest.push(proyecto.idProyecto);
    this.autotestService.startNewAutotest(proyecto.idProyecto).subscribe((result: autotestProyecto) => {
      console.log(result)
      let index = this.runningAutotest.indexOf(proyecto.idProyecto);
      if (index !== -1) {
        this.runningAutotest.splice(index, 1);
      }
      if (this.lastAutotests.find(test => test.idProyecto == result.idProyecto) != undefined) {
        let arr = this.lastAutotests.map(test => {
          if (test.idProyecto == result.idProyecto) {
            return result;
          }
          return test;
        });
        this.lastAutotests = arr;
      } else {
        this.lastAutotests.push(result);
      }
    })
  }

  isRunningAutotest(idProyecto: string) {
    return this.runningAutotest.find(test => test == idProyecto) != undefined;
  }

  countLumsByStatus(autotestProyecto: autotestProyecto, status: string) {
    return autotestProyecto.luminariasFinished.filter(test => test.status == status).length;
  }

  getHasEmergencyModule(autotest: autotest) {
    return (autotest.emg_LED != 0 || autotest.emg_LOAD != 0 || autotest.emg_BATT != 0);
  }

  getLastEmergency(autotest: autotest) {
    if (autotest.emg_LED == 2) {
      return 1;
    } else if (autotest.emg_BATT == 2 || autotest.emg_LOAD == 2) {
      return 2
    } else {
      return 0;
    }
  }

  openWarning(proyecto: proyecto) {
    if (!this.isRunningAutotest(proyecto.idProyecto)) {
      this.startNewAutotest(proyecto);
    }
  }

  goToInfoLuminaria(autotest: autotest) {
    this.deviceService.setSelectedLuminariaById(autotest.idDispositivo);
    this.navigation.toDevices();
  }

  seeHistory(proyecto: proyecto) {
    this.showHistory = true;
    this.showAutotest = false;
    this.selectedProyecto = proyecto;
    this.loadedHistory = false;
    this.autotestService.getAutotestProyectoByIdProyecto(proyecto.idProyecto).subscribe((result: Array<autotestProyecto>) => {
      this.autotestProyectoHistory = result;
      this.loadedHistory = true;
    })
  }

  selectAutotest(autotestProyecto: autotestProyecto) {
    if (autotestProyecto != undefined) {
      if (this.selectedProyecto == undefined) {
        this.selectedProyecto = this.user.getProyectos().find(proyecto => proyecto.idProyecto == autotestProyecto.idProyecto)
      }
      this.showHistory = false;
      this.showAutotest = true;
      this.loadedHistory = false;
      this.autotestProyectoHistory = [];
      this.selectedAutotestProyecto = autotestProyecto;
    }
  }

  returnHome() {
    this.init();
    this.showHistory = false;
    this.showAutotest = false;
    this.selectedAutotestProyecto = undefined;
    this.selectedProyecto = undefined;
    this.autotestProyectoHistory = [];
    this.loadedHistory = false;
  }

  returnSelectProyecto() {
    if (this.selectedProyecto != undefined) {
      this.seeHistory(this.selectedProyecto);
    } else {
      this.returnHome();
    }
  }

  addDynamicAutotest(autotest: autotest) {
    let autotestProyecto: autotestProyecto = this.lastAutotests.find(lastTest => lastTest.status == 'Running');
    autotestProyecto.luminariasFinished.push(autotest);
    autotestProyecto.lumsFinished = autotestProyecto.luminariasFinished.length;if (this.selectedAutotestProyecto != undefined && this.selectedAutotestProyecto.idAutotest == autotest.idAutotest) {
      this.selectedAutotestProyecto.luminariasFinished.sort((a,b) => b.stamp_T - a.stamp_T)
    }
    if (autotestProyecto.lumsFinished == autotestProyecto.lumsTotal) {
      this.init();
      if (this.selectedAutotestProyecto != undefined && this.selectedAutotestProyecto.idAutotest == autotest.idAutotest) {
        this.selectedAutotestProyecto.status = 'Done';
        this.selectedAutotestProyecto.endTime = autotest.stamp_T;
      } else if (this.autotestProyectoHistory.length > 0 && this.selectedProyecto != undefined
        && this.autotestProyectoHistory.find(test => test.idAutotest == autotest.idAutotest) != undefined) {
        this.seeHistory(this.selectedProyecto);
      }
    }

  }

  showPCG(autotest: autotest) {
    if (autotest.status == 'YES') {
      if (autotest.pcg == 255) {
        return "No driver"
      }
      if ((autotest.emg_LED == 2 && autotest.emg_BATT == 2 && autotest.emg_LOAD == 2) || autotest.pcg > 100) {
        return 'Read error';
      }
      return autotest.pcg + '%';
    } else {
      return '--';
    }
  }

  showConsumption(autotest: autotest) {
    if (autotest.status == 'YES') {
      if (autotest.w == 65535 || autotest.w == 65536) {
        return "No driver"
      }
      if ((autotest.emg_LED == 2 && autotest.emg_BATT == 2 && autotest.emg_LOAD == 2) || autotest.w < 0) {
        return 'Read error';
      }
      return autotest.w + ' W';
    } else {
      return '--';
    }
  }

  cancelAutotest(autotestP: autotestProyecto) {
    this.autotestService.cancelAutotest(autotestP.idAutotest).subscribe(() => {
      autotestP.status = 'Cancelled';
      let index = this.runningAutotest.indexOf(autotestP.idProyecto);
      if (index !== -1) {
        this.runningAutotest.splice(index, 1);
      }
    });
  }
}